// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/" + (chunkId === "37" ? "markdown" : chunkId) + "." + {"341": "3ebda6b5","37": "9e0794fb",}[chunkId] + ".chunk.css"
}